import { InputOptions } from 'types/input'

/** A single filterable field as described by the backend's `filterMeta`. */
export type FilterMetaField = {
  field: string
  type: 'enum' | 'text' | 'exact'
  options?: string[]
}

/** The `filterMeta` envelope returned alongside every log list response. */
export type FilterMeta = {
  fields?: FilterMetaField[]
  dateRange?: {
    field?: string
    from?: string
    to?: string
    aliases?: { from?: string[]; to?: string[] }
  }
}

/**
 * Returns the enum `options` the backend advertises for a given field via
 * `filterMeta`, or an empty array when none are available.
 */
export const getFilterMetaOptions = (
  filterMeta: FilterMeta | undefined | null,
  field: string,
): string[] =>
  filterMeta?.fields?.find((item) => item.field === field)?.options ?? []

/**
 * Builds dropdown options for an enum filter. Prefers the live `options` from
 * `filterMeta`; falls back to a hardcoded list so the form still works before
 * the list response arrives (or against an older backend). The values are sent
 * to the server verbatim, so the raw value doubles as the label.
 */
export const buildEnumOptions = (
  filterMeta: FilterMeta | undefined | null,
  field: string,
  fallback: string[],
): InputOptions[] => {
  const apiOptions = getFilterMetaOptions(filterMeta, field)
  const values = apiOptions.length > 0 ? apiOptions : fallback

  return [
    { label: '--- NONE ---', value: 'NONE' },
    ...values.map((value) => ({ label: value, value })),
  ]
}
